import React, { useEffect } from 'react'
import { formatCurrency, formatDateOnFrontWithoutTime } from '../../../lib/helpers';
import MaterailTable from '../Elements/MaterialTable';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrencySymbolByCurrencyId } from '../../../common/helpers/getCurrencySymbolByCurrencyId';
import { useLoading } from '../../../hooks/useLoading';
import { tableEmptyMessages } from '../../../constants/messages/tableEmptyMessages';
import { ProgressLoader } from '../Elements';
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../../store/recoil/tenant/atoms';

interface OrderInstallmentsReportProps {
  formFilterRef: React.Ref<HTMLDivElement> | undefined;
  getHeadCells: (values: any) => void;
  tableSelectedRows: any;
  isDetail: boolean;
  totalAmountCurrency: number;
}

const OrderInstallmentsReportTable: React.FC<OrderInstallmentsReportProps> = ({ getHeadCells, tableSelectedRows, isDetail, totalAmountCurrency }) => {
  const { firmInformations } = useRecoilValue(tenantState);
  const dispatch = useDispatch<any>();

  const {
    orderInstallmentsReport,
    isFetching: isFetchingDetail,
    isloadingIntegration: isloadingIntegrationDetail,
    isFetchComplete: isFetchCompleteDetail
  } = useSelector((state: any) => state.orderInstallmentsReport);

  const {
    orderInstallmentsReport: orderInstallmentsReportByVp,
    isFetching: isFetchingVp,
    isloadingIntegration: isloadingIntegrationVp,
    isFetchComplete: isFetchCompleteVp
  } = useSelector((state: any) => state.orderInstallmentsReportPerVp);

  // isDetail parametresine göre data seç
  const tableData = isDetail ? orderInstallmentsReport : orderInstallmentsReportByVp;
  const isFetching = isDetail ? isFetchingDetail : isFetchingVp;
  const isloadingIntegration = isDetail ? isloadingIntegrationDetail : isloadingIntegrationVp;
  const isFetchComplete = isDetail ? isFetchCompleteDetail : isFetchCompleteVp;

  useEffect(() => {
    getHeadCells(headCells);
  }, [isFetching]);

  const loading = useLoading(isFetching);

  const headCells = isDetail ? [
    {
      id: 'id',
      numeric: false,
      label: 'ID',
      isprimary: true,
      className: "min-w-[80px]",
      colWidth: 10, // For excel
      hide: true,
      exceptToExcel: true
    },
    {
      id: 'orderdate',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Tarihi',
      className: "min-w-[150px]",
      isRender: true,
      colWidth: 25, // For excel
      renderRow: (row: any) => {
        return (
          <div className="">
            {formatDateOnFrontWithoutTime(row.orderdate)}
          </div>
        );
      }
    },
    {
      id: 'firstamount',
      numeric: true,
      disablePadding: false,
      label: 'Tutar',
      className: "min-w-[140px]",
      isMoney: true,
      maxLength: 15,
      colWidth: 20, // For excel
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.firstamount)) + getCurrencySymbolByCurrencyId(row.currencyid)}
          </>
        )
      }
    },
    {
      id: 'installment',
      numeric: true,
      disablePadding: false,
      label: 'Taksit',
      className: "min-w-[80px]",
      forcealign: "center",
      maxLength: 42,
      colWidth: 20, // For excel
    },
    {
      id: "servicecommissionrate",
      disablePadding: false,
      isMoney: true,
      label: "Hizmet Komisyon Oranı",
      className: "max-w-[220px] min-w-[205px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.servicecommissionrate || 0))}%
          </>
        )
      }
    },
    {
      id: 'netamount',
      numeric: true,
      disablePadding: false,
      label: 'Hesaba Geçecek Tutar',
      className: "min-w-[195px]",
      isMoney: true,
      maxLength: 15,
      colWidth: 20, // For excel
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.netamount)) + getCurrencySymbolByCurrencyId(row.currencyid)}
          </>
        )
      }
    },
    {
      id: "bankcommissionamount",
      disablePadding: false,
      isMoney: true,
      label: "Hizmet Komisyon Tutarı",
      className: "max-w-[220px] min-w-[205px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.bankcommissionamount || 0)) + getCurrencySymbolByCurrencyId(row.currencyid)}
          </>
        )
      }
    },
    {
      id: 'paymentdate',
      numeric: true,
      disablePadding: false,
      label: 'Geri Ödeme Tarihi',
      className: "min-w-[165px]",
      isRender: true,
      colWidth: 25, // For excel
      renderRow: (row: any) => {
        return (
          <div className="">
            {formatDateOnFrontWithoutTime(row.paymentdate)}
          </div>
        );
      }
    },
    {
      id: "commissionrate",
      disablePadding: false,
      isMoney: true,
      label: "Müşteriye Yansıtılan Oran",
      className: "min-w-[215px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.commissionrate || 0))}%
          </>
        )
      }
    },
    {
      id: "customercommissionamount",
      disablePadding: false,
      isMoney: true,
      label: "Müşteriye Yansıtılan Tutar",
      className: "min-w-[215px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.customercommissionamount || 0)) + getCurrencySymbolByCurrencyId(row.currencyid)}
          </>
        )
      }
    },
    {
      id: "commissiondifference",
      disablePadding: false,
      isMoney: true,
      label: "Müşteri-Hizmet Komisyon Farkı",
      className: "min-w-[250px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.commissiondifference || 0)) + getCurrencySymbolByCurrencyId(row.currencyid)}
          </>
        )
      }
    },
    {
      id: "ordercode",
      disablePadding: false,
      label: "Sipariş Kodu",
      className: "max-w-[220px] min-w-[130px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
    },
  ] : [
    {
      id: 'id',
      numeric: false,
      label: 'ID',
      isprimary: true,
      className: "min-w-[80px]",
      colWidth: 10, // For excel
      hide: true,
      exceptToExcel: true
    },
    {
      id: 'paymentDate',
      numeric: true,
      disablePadding: false,
      label: 'Geri Ödeme Tarihi',
      className: "w-[165px]",
      isRender: true,
      colWidth: 25, // For excel
      renderRow: (row: any) => {
        return (
          <div className="">
            {formatDateOnFrontWithoutTime(row.paymentDate)}
          </div>
        );
      }
    },
    {
      id: 'vpDisplayName',
      numeric: true,
      disablePadding: false,
      label: 'Ödeme Altyapısı',
      className: "min-w-[155px]",
      maxLength: 15,
      colWidth: 20, // For excel
    },
    {
      id: 'totalAmount',
      numeric: true,
      disablePadding: false,
      label: 'Hesaba Geçecek Tutar',
      className: "w-[195px]",
      isMoney: true,
      maxLength: 15,
      colWidth: 20, // For excel
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.totalAmount)) + getCurrencySymbolByCurrencyId(row.currencyId)}
          </>
        )
      }
    },
    // {
    //   id: 'totalTL',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Hesaba Geçecek TL',
    //   className: "min-w-[150px]",
    //   isMoney: true,
    //   maxLength: 15,
    //   colWidth: 20, // For excel
    //   isRender: true,
    //   hide: firmInformations.isCurrency? false: true,
    //   showTotal: true,
    //   renderRow: (row: any) => {
    //     return (
    //       <>
    //         {formatCurrency(parseFloat(row.totalTL)) + getCurrencySymbolByCurrencyId(row.currencyId)}
    //       </>
    //     )
    //   }
    // },
    // {
    //   id: 'totalEUR',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Hesaba Geçecek EUR',
    //   className: "min-w-[150px]",
    //   isMoney: true,
    //   maxLength: 15,
    //   colWidth: 20, // For excel
    //   isRender: true,
    //   hide: firmInformations.isCurrency? false: true,
    //   showTotal: true,
    //   renderRow: (row: any) => {
    //     return (
    //       <>
    //         {formatCurrency(parseFloat(row.totalEUR)) + getCurrencySymbolByCurrencyId(row.currencyId)}
    //       </>
    //     )
    //   }
    // },
    // {
    //   id: 'totalUSD',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Hesaba Geçecek USD',
    //   className: "min-w-[150px]",
    //   isMoney: true,
    //   maxLength: 15,
    //   colWidth: 20, // For excel
    //   isRender: true,
    //   hide: firmInformations.isCurrency ? false: true,
    //   showTotal: true,
    //   renderRow: (row: any) => {
    //     return (
    //       <>
    //         {formatCurrency(parseFloat(row.totalUSD)) + getCurrencySymbolByCurrencyId(row.currencyId)}
    //       </>
    //     )
    //   }
    // },
    // {
    //   id: 'totalGBP',
    //   numeric: true,
    //   disablePadding: false,
    //   label: 'Hesaba Geçecek GBP',
    //   className: "min-w-[150px]",
    //   isMoney: true,
    //   maxLength: 15,
    //   colWidth: 20, // For excel
    //   isRender: true,
    //   hide: true,
    //   showTotal: true,
    //   renderRow: (row: any) => {
    //     return (
    //       <>
    //         {formatCurrency(parseFloat(row.totalGBP)) + getCurrencySymbolByCurrencyId(row.currencyId)}
    //       </>
    //     )
    //   }
    // },
    {
      id: "customerCommissionAmount",
      disablePadding: false,
      isMoney: true,
      label: "Müşteri Komisyon Tutarı",
      className: "w-[205px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.customerCommissionAmount || 0)) + getCurrencySymbolByCurrencyId(row.currencyId)}
          </>
        )
      }
    },
    {
      id: "bankComissionAmount",
      disablePadding: false,
      isMoney: true,
      label: "Hizmet Komisyon Tutarı",
      className: "w-[201px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.bankComissionAmount || 0)) + getCurrencySymbolByCurrencyId(row.currencyId)}
          </>
        )
      }
    },
    {
      id: "commissionDifference",
      disablePadding: false,
      isMoney: true,
      label: "Hizmet-Müşteri Komisyon Farkı",
      className: "w-[250px]",
      maxLength: 30,
      colWidth: 30,
      // hide: showTableDetail ? false :true
      isRender: true,
      showTotal: true,
      renderRow: (row: any) => {
        return (
          <>
            {formatCurrency(parseFloat(row.commissionDifference || 0)) + getCurrencySymbolByCurrencyId(row.currencyId)}
          </>
        )
      }
    },
  ];

  function LinearColor() {
    if (isloadingIntegration) {
      return (
        <ProgressLoader />
      );
    }
  }

  return (
    <>
      {LinearColor()}
      <MaterailTable
        ref={tableSelectedRows}
        headerCells={headCells}
        tableData={tableData}
        isRowSelect={true}
        isLoading={loading}
        emptyMessage={isFetchComplete ? tableEmptyMessages.isFilteredDataNotFound : tableEmptyMessages.emptyString}
        // totalParameter={isDetail ?"netamount" : "totalAmount"}
        // totalLabel="Hesaba Geçecek Tutar" 
        // secondTotalParamater={isDetail ? "commissiondifference" : "commissionDifference"}
        // secondTotalLabel="Komisyon Farkı"
        showTotalRow={true}
        totalAmountCurrency={totalAmountCurrency}
      />
    </>
  )
}

export default OrderInstallmentsReportTable